import { EventEmitter } from '../EventEmitter'
import modulesData from './mockData/TypeModule.json'
import Mockjs from "mockjs"
import { uuid, storage, encrypt } from "../utils/tools"
import Chance from './widget-libs/chance'
import testMqttData from './mockData/test.json'
const $Chance = new Chance()
const $key = 'hyHGsdU86ih5'


/**
 * @class
 * @classdesc 模拟数据
 */
export default class Mock extends EventEmitter {
    constructor(proc) {
        super()
        this.proc = proc;

        // this._modulesData()
    }

    showType = {
        "boolean": "boolean",
        "string": "string",
        "enum": "enum",
        "monitor": "monitor"
    }

    // mqtt模拟数据
    _mqttData(data) {
        let mqtt = {
            uuid: uuid(),
            data: {}
        }
        for (let key in data) {
            data[key].forEach(item => {
                switch (key) {
                    case this.showType.boolean:
                        mqtt.data[item] = $Chance.integer({ min: 0, max: 1 })
                        break;
                    case this.showType.enum:
                        mqtt.data[item] = $Chance.integer({ min: 0, max: 3 })
                        break;
                    case this.showType.monitor:
                        mqtt.data[item] = $Chance.floating({ min: 0, max: 100, fixed: 2 });
                        break;
                    case this.showType.string:
                        mqtt.data[item] = $Chance.integer({ min: 0, max: 100 })
                        break;
                }
            })
        }
        // this.proc.setData({
        //     mqttData: mqtt
        // })
    }

    // 所有的模块的模拟数据
    _modulesData() {
        this.proc.setData({
            mqttData: testMqttData
        }).then(res => {
            this.onloaded && this.onloaded(true)
        })
        let url = new RegExp(/api\/type\/.*\/TypeModule$/g);
        Mockjs.mock(url, modulesData)


    }

    drviceState = {
        start: "运行",
        stop: "停止",
        error: "故障",
    }

    // 获取模块信息
    getModules() {
        const colors = ['#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2',
            '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2', '#0182e2']
        colors[20] = '#006f8b';
        colors[17] = '#00c2eb';
        colors[8] = '#ffe97c';
        colors[9] = '#ffe97c';
        colors[21] = '#967B00';
        colors[21] = '#967B00';
        colors[18] = '#435DCC';
        colors[4] = '#FB9A00';
        colors[5] = '#FB9A00';
        colors[6] = '#007032';
        colors[7] = '#007032';
        this.DPC = this.proc.make('DPC')
        // 获取未修改过多嗯原始数据
        let originalModulesData = this.DPC.originalModulesData;
        let modulesCard = [];
        originalModulesData.forEach((item, index) => {
            // 模块
            let obj = {
                label: item.moduleName,
                hasNotifi: false,
                id: item.id,
                color: colors[index],
                //   color: "#888888",
                drvices: [],
            };
            // 子项
            item.controls.forEach((controlsItem) => {
                let controlsItemObj = {
                    label: controlsItem.controlName,
                    state: this.drviceState.start,
                    type: controlsItem.showType,
                    id: controlsItem.id,
                    data: [],
                };

                if (!controlsItem.currentValue) {
                    controlsItemObj.state = this.drviceState.stop
                }

                switch (controlsItem.showType) {
                    case "string":
                        controlsItemObj.data.push(
                            {
                                label: "反馈值",
                                value:
                                    String(controlsItem.currentValue) +
                                    (controlsItem.unit[1] ?? controlsItem.unit[1]),
                            },
                            {
                                label: "设定值",
                                value:
                                    String(controlsItem.settingValue) +
                                    (controlsItem.unit[1] ?? controlsItem.unit[1]),
                            }
                        );
                        break;
                    case "boolean":

                        controlsItemObj.data.push({
                            label: controlsItem.controlName,
                            value: controlsItem.displayValue ? "开" : "关",
                        });
                        break;
                    case "monitor":

                        controlsItemObj.data.push({
                            label: controlsItem.controlName,
                            value:
                                String(controlsItem.displayValue) ?? $Chance.integer({ min: 0, max: 10000 }) +
                                (controlsItem.unit[1] ?? controlsItem.unit[1]),
                        });
                        break;
                    default:
                        controlsItemObj.data.push({
                            label: controlsItem.controlName,
                            value: controlsItem.displayValue,
                        });
                }
                obj.drvices.push(controlsItemObj);
            });

            modulesCard.push(obj);
        });
        return modulesCard;
    }
    // 格式化时间
    formatDate(date) {
        date = new Date(date);
        let myyear = date.getFullYear();
        let mymonth = date.getMonth() + 1;
        let myweekday = date.getDate();
        mymonth < 10 ? mymonth = "0" + mymonth : mymonth;
        myweekday < 10 ? myweekday = "0" + myweekday : myweekday;
        return `${myyear}-${mymonth}-${myweekday}`;
    }

    // 获取当前月有多少天的时间戳
    /**
     * 
     * @param {number} m 月份从0开始
     * @returns 
     */
    getDate(m) {
        let day = new Date().getDate();
        let month = typeof m === 'number' ? m + 1 : new Date().getMonth() + 1;
        let year = new Date().getFullYear();
        // 获取当前有多少天
        let days = new Date(year, month, 0).getDate()
        let now = new Date(day);
        let current_month_num = days;
        let current_month = [];

        for (let i = 1; i <= current_month_num; i++) {
            let day = now.setDate(i);

            current_month.push(day);
        }
        return current_month;
    }


    // 保存数据
    async save(name, val) {
        let enData = encrypt.encrypt(JSON.stringify(val), $key)
        let msg = await storage.setItem(name, enData)
        if (msg) {
            return msg
        } else {
            return null
        }
    }
    // 获取指定数据
    async getData(name) {
        let _statistics = await storage.getItem(name) || null;
        if (typeof _statistics === 'string') {
            // 解密数据
            _statistics = JSON.parse(encrypt.decrypt(_statistics, $key))
        }
        return _statistics
    }

    // 保存的数据名称
    DBName = {
        WATER: 'Water_statistisc',
        PAC: 'PAC_statistics',
        NH: 'NH_monitor'
    }

    async findData(name, start, end) {
        /**
         * @type {Array}
         */
        let arr = await this.getData(name) || [];
        return arr.filter(item => {
            let time = new Date(item.createTime)
            if (time > start && time <= end) {
                return item;
            }
        })
    }

    /**
     * 创建所有加药数据
     * @param {Array<number>} years 
     * @returns 
     */
    async createPACAllData(years = [new Date().getFullYear()]) {
        let dbname = this.DBName.PAC
        let dataObj = await this.getData(dbname) || []
        if (dataObj.length && new Date(dataObj.slice(-1)[0].createTime) > new Date()) {
            return dataObj
        }
        let _Date = null;
        for (let i = 0; i < years.length; i++) {
            let year = years[i];
            if (typeof year != 'number') return;
            for (let j = 0; j < 12; j++) {
                // 每月时间
                _Date = new Date(year, j + 1, 0);
                let days = _Date.getDate();
                for (let n = 0; n < days; n++) {
                    let obj = {
                        createTime: new Date(year, j, n + 1),
                        data: [
                            {
                                label: 'PAC',
                                value: $Chance.integer({ min: 70, max: 120 }),
                                unit: ''
                            },
                            {
                                label: 'PAM',
                                value: $Chance.integer({ min: 70, max: 120 }),
                                unit: ''
                            },
                             {
                                label: '碳源',
                                value: $Chance.integer({ min: 70, max: 120 }),
                                unit: ''
                            },
                             {
                                label: '次氯酸钠',
                                value: $Chance.integer({ min: 70, max: 110 }),
                                unit: ''
                            }
                        ]
                    }
                    dataObj.push(obj)
                }

            }

        }
        this.save(dbname, dataObj)

        return dataObj;
    }

    /**
     * 创建进出水统计数据
     * @param {Array<number>} years 
     * @returns 
     */
    async createWaterStatistiscData(years = [new Date().getFullYear()]) {
        let dbname = this.DBName.WATER
        let dataObj = await this.getData(dbname) || []
        if (dataObj.length && new Date(dataObj.slice(-1)[0].createTime) > new Date()) {
            return dataObj
        }
        let _Date = null;
        for (let i = 0; i < years.length; i++) {
            let year = years[i];
            if (typeof year != 'number') return;
            for (let j = 0; j < 12; j++) {
                // 每月时间
                _Date = new Date(year, j + 1, 0);

                let days = _Date.getDate();

                for (let n = 0; n < days; n++) {
                    let obj = {
                        createTime: new Date(year, j, n + 1),
                        data: [
                            {
                                label: '进水',
                                type: 'in',
                                value: $Chance.integer({ min: 14000, max: 14500 }),
                                unit: ''
                            },
                            {
                                label: '出水',
                                type: 'out',
                                value: $Chance.integer({ min: 14000, max: 14500 }),
                                unit: ''
                            }
                        ]
                    }
                    dataObj.push(obj)
                }

            }

        }
        this.save(dbname, dataObj)
        return dataObj;
    }

    /**
     * 创建能耗统计数据
     * @param {Array<number>} years 
     */
    async createNHMonitorData(years = [new Date().getFullYear()]) {
        let dbname = this.DBName.NH
        let dataObj = await this.getData(dbname) || []
        if (dataObj.length && new Date(dataObj.slice(-1)[0].createTime) > new Date()) {
            return dataObj
        }
        let _Date = null;
        for (let i = 0; i < years.length; i++) {
            let year = years[i];
            if (typeof year != 'number') return;
            for (let j = 0; j < 12; j++) {
                // 每月时间
                _Date = new Date(year, j + 1, 0);

                let days = _Date.getDate();

                for (let n = 0; n < days; n++) {
                    let obj = {
                        createTime: new Date(year, j, n + 1),
                        data: [
                            {
                                label: '能耗',
                                value: $Chance.integer({ min: 90, max: 120 }),
                                unit: 'kwh'
                            }
                        ]
                    }
                    dataObj.push(obj)
                }

            }
        }
        this.save(dbname, dataObj)
        return dataObj;
    }
    /**
     *QY1:缺氧池1
     *   YY1:厌氧池1
      *  YY2:厌氧池2
       * QY2:缺氧池2
       * HY1:好氧池1,
        *HY2:好氧池2,
        *ECC1:二层池1,
        *ECC2:二层池2,
        *WSJ:卫生间,
        *ZBS1:值班室1,
        *GYS:更衣室,
        *CSJC:出水监测,
        *ZBS2:值班室2,
        *JSJC:进水监测,
        *WFJ:危废间,
        *NSC:浓缩池,
        *ZNC:储泥池
        *BSJLC:巴式计量槽
     */
    drviceType = {
        QY1: 'QY1',
        YY1: 'YY1',
        YY2: 'YY2',
        QY2: 'QY2',
        HY1: 'HY1',
        HY2: 'HY2',
        ECC1: 'ECC1',
        ECC2: 'ECC2',
        WSJ: 'WSJ',
        ZBS1: 'ZBS1',
        GYS: 'GYS',
        CSJC: 'CSJC',
        ZBS2: 'ZBS2',
        JSJC: 'JSJC',
        WFJ: 'WFJ',
        NSC: 'NSC',
        ZNC: 'ZNC',
        BSJLC: 'BSJLC',
        ECC1_1: 'ECC1_1',
        ECC2_2: 'ECC2_2',
        XLCSQ: 'XLCSQ',
        PAM: 'PAM',
        CYJ: 'CYJ',
        LBLC: 'LBLC',
        CXD: 'CXD',
        FJ: 'FJ',
        WNBC: 'WNBC',
        CC: 'CC',
        XGS: 'XGS',
        XNC1: 'XNC1',
        XNC2: 'XNC2',
        HNC1: 'HNC1',
        HNC2: 'HNC2',
        GMC1: 'GMC1',
        GMC2: 'GMC2',

    }
    drviceState = {
        start: 0, //"运行"
        stop: 1,//"停止",
        error: 2,//"故障",
    };
    /**
     * 创建报警信息
     */
    createWranInfoData() {
        let modules = this.getModules();
        let pos = this.getDrviceData()

        console.log(modules)
        let drvicesWarn = [
            {
                label: '厌氧池1',
                id: this.drviceType.YY1,
                isWarn: true,
                moduleID: '',
                data: [
                    {
                        label: '搅拌机2A',
                        state: this.drviceState.start
                    },
                    {
                        label: '搅拌机2#',
                        state: this.drviceState.error
                    },
                    {
                        label: '搅拌机1A',
                        state: this.drviceState.stop
                    },
                    {
                        label: '搅拌机1#',
                        state: this.drviceState.start
                    }
                ]
            }
        ]

        pos.forEach(item => {
            // 获取每个视角的坐标
            item.forEach(el => {

                modules.forEach(drmodule => {
                    if (el.moduleID > -1 && el.moduleID == drmodule.id) {
                        
                        let obj = {
                            label: el.name,
                            moduleID: drmodule.id,
                            isWarn:  false,
                            id: el.id,
                            warnShow:false,
                            warn:null,
                            data: []
                        }
                        drmodule.drvices.forEach(dr => {
                            if( dr.state == this.drviceState.error){
                                obj.isWarn = true;
                            }
                            let drviceObj = {
                                label: dr.label,
                                state: dr.state
                            }
                            obj.data.push(drviceObj)
                        })
                        drvicesWarn.push(obj)
                    }

                })
            })
        })

        return drvicesWarn
    }

    /**
     * 清除所有数据缓存并重新生成
     */
    async clearCache() {
        await storage.removeItem(this.DBName.NH)
        await storage.removeItem(this.DBName.WATER)
        await storage.removeItem(this.DBName.PAC)
        storage.remove('runActionConfig')
        storage.remove('weatherData')
        location.reload()
    }

    /**
     * 设置坐标信息
     * @param {object} data 
     */
    setDrviceData(data) {
        storage.set('drvicePos', data)
    }
    /**
     * 获取坐标信息
     */
    getDrviceData() {
        return  [[{"id":"XLCSQ","name":"旋流沉沙器","show":true,"moduleID":"1269","pos":[431,267]},{"id":"XGS","name":"细格栅","show":true,"pos":[520,308],"moduleID":"1267"},{"id":"PAM","name":"PAM加药","show":true,"moduleID":"1287","pos":[348,419]},{"id":"CYJ","name":"储药间","show":true,"moduleID":"1287","pos":[268,475]},{"id":"LBLC","name":"滤布滤池","show":true,"moduleID":"1280","pos":[411,537]},{"id":"FJ","name":"风机","show":true,"moduleID":"1283","pos":[528,581]},{"id":"WNBC","name":"污泥泵车间","show":true,"moduleID":"1285","pos":[657,532]},{"id":"ECC1_1","name":"二沉池1","show":true,"moduleID":"1274","pos":[623,161]},{"id":"ECC2_2","name":"二沉池2","show":true,"moduleID":"1275","pos":[862,258]},{"id":"CC","name":"除臭设备","show":true,"moduleID":"1284","pos":[603,380]},{"id":"CXD","name":"紫外线消毒","show":true,"moduleID":"1282","pos":[344,672]}],[{"id":"QY1","name":"缺氧池1","show":true,"pos":[176,165]},{"id":"YY1","name":"厌氧池1","show":true,"pos":[312,125],"moduleID":"1270"},{"id":"YY2","name":"厌氧池2","show":true,"pos":[392,101],"moduleID":"1271"},{"id":"QY2","name":"缺氧池2","show":true,"pos":[517,69]},{"id":"HY1","name":"好氧池1","show":true,"pos":[352,252],"moduleID":"1272"},{"id":"HY2","name":"好氧池2","show":true,"pos":[631,155],"moduleID":"1273"},{"id":"ECC1","name":"二层池1","show":true,"pos":[514,312],"moduleID":"1274"},{"id":"ECC2","name":"二层池2","show":true,"pos":[836,189],"moduleID":"1275"},{"id":"JSJC","name":"进水检测","show":true,"pos":[964,344],"moduleID":"1286"},{"id":"WFJ","name":"危废间","show":true,"pos":[1037,313]},{"id":"NSC","name":"浓缩池","show":true,"pos":[646,559]},{"id":"ZNC","name":"储泥池","show":true,"pos":[882,674]},{"id":"BSJLC","name":"巴氏计量槽","show":true,"pos":[1486,533]},{"id":"CSJC","name":"出水检测","show":true,"moduleID":"1286","pos":[943,282]}],[{"id":"QY1","name":"缺氧池1","show":true,"pos":[1301,365]},{"id":"YY1","name":"厌氧池1","show":true,"pos":[1225,418],"moduleID":"1270"},{"id":"YY2","name":"厌氧池2","show":true,"pos":[1147,460],"moduleID":"1271"},{"id":"QY2","name":"缺氧池2","show":true,"pos":[991,545]},{"id":"HY1","name":"好氧池1","show":true,"pos":[1035,326],"moduleID":"1272"},{"id":"HY2","name":"好氧池2","show":true,"pos":[786,448],"moduleID":"1273"},{"id":"ECC1","name":"二层池1","show":true,"pos":[795,225],"moduleID":"1274"},{"id":"ECC2","name":"二层池2","show":true,"pos":[510,341],"moduleID":"1275"},{"id":"XNC1","name":"絮凝池1","show":true,"moduleID":"1277","pos":[523,194]},{"id":"HNC1","name":"混凝池1","show":true,"moduleID":"1276","pos":[567,210]},{"id":"HNC2","name":"混凝池2","show":true,"moduleID":"1276","pos":[309,284]},{"id":"GMC1","name":"高密池1","show":true,"moduleID":"1278","pos":[467,229]},{"id":"GMC2","name":"高密池2","show":true,"moduleID":"1279","pos":[378,254]},{"id":"XNC2","name":"絮凝池2","show":true,"moduleID":"1277","pos":[249,261]}]]
    }
    /**
     * 清除坐标
     */
    clearDrviceData() {
        
        storage.remove('drvicePos')
    }
}